import { Input } from "antd";
import scanIcon from "../../assets/images/Qrscan-Icon.png";
import copyIcon from "../../assets/icons/copy-07.png";
import { SuccessTag } from "../index";
import { useReferralInvites } from "../../data/live";

const APP_ORIGIN = window.location.origin;

const ReferralCenter = () => {
  const { summary, loading } = useReferralInvites();
  const referralLink = summary?.referralCode
    ? `${APP_ORIGIN}/signup?ref=${summary.referralCode}`
    : "";
  const howItWorks = [
    {
      tagName: "Invite network",
      para: "Refer contacts via email or by using the referral link for your account.",
    },
    {
      tagName: "Eligibility",
      para: "Invite status is tracked by the backend referral service.",
    },
    {
      tagName: "Reward Condition",
      para: "Reward eligibility appears after invite acceptance data is returned by the backend.",
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <span className="fs-5 fw-semibold">
          Invite your network to earn rewards
        </span>

        <span className="fs12px" style={{ color: "#7D7D7D" }}>
          Accepted invites:{" "}
          <span style={{ color: "#1bbb6b" }}>
            {loading ? "..." : summary?.accepted ?? 0}
          </span>
        </span>
      </div>

      <div className="col-lg-6 mt-3">
        <div className="border rounded-3">
          <div className="border-bottom p-3">
            <span className="fs14px fw-bold">Your referral code</span>
          </div>

          <div className="d-flex flex-column gap-3 justify-content-center align-items-center p-3">
            <div>
              <img src={scanIcon} alt="scan" width={84} height={84} />
            </div>
            <span className="fw-semibold text-center">
              {summary?.referralCode || "No referral code available"}
            </span>
            <span
              className="fs12px text-center px-3"
              style={{ color: "#7D7D7D" }}
            >
              Referral totals are loaded from the backend invite ledger.
            </span>
          </div>
        </div>
      </div>

      <div className="col-lg-6 mt-3 ">
        <div className="border rounded-3 h-100">
          <div className="border-bottom p-3">
            <span className="fs14px fw-bold">Invite your network</span>
          </div>

          <div className="d-flex flex-column gap-3 p-3">
            <div className="d-flex flex-column gap-2">
              <label className="fs12px">Invite via email</label>
              <Input className="p-3" placeholder="youremail@gmail.com" />
            </div>
            <div className="d-flex flex-column gap-2">
              <label className="fs12px">Share your invite link</label>
              <Input
                className="p-3"
                value={referralLink}
                readOnly
                suffix={
                  <img
                    src={copyIcon}
                    alt="copy"
                    className="cursor-pointer"
                    onClick={() => referralLink && navigator.clipboard?.writeText(referralLink)}
                  />
                }
              />
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 mt-3 ">
        <div className="border rounded-3 h-100">
          <div className="border-bottom p-3">
            <span className="fs14px fw-bold">How it works</span>
          </div>

          <div className="d-flex flex-wrap flex-md-nowrap align-items-center justify-content-md-between justify-content-center gap-3 p-3">
            {howItWorks.map(({ tagName, para }) => (
              <div
                className="d-flex flex-column gap-3 how-it-work-section align-self-start align-items-center"
                key={tagName}
              >
                <SuccessTag
                  tagName={tagName}
                  className={" fs-5 fw-semibold px-5 text-center py-3 rounded-3"}
                />
                <span
                  className="fs12px text-center"
                  style={{ color: "#7D7D7D", width: "82%" }}
                >
                  {para}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferralCenter;
